import React from 'react';
import { MdArrowBackIos } from "react-icons/md"
const openNav = () => {
  if (document.getElementById("mySidenav")) {
    document.getElementById("mySidenav").style.width = "100%";
  }
}

const Header = (props) => {
  //console.log(props);
  const {user} = props;
  //console.log(user)
  if (user) {
    return <AuthHeader />;
  } else {
    return <NoAuthHeader />;
  }
  
}

const AuthHeader = () => {
  return (
    <header className="header d-flex justify-content-between">
      <div>
        <MdArrowBackIos onClick={() => {window.history.back()}} size="30" className="arrowBackBtn mt-1"/>
      </div>
      <h1 className="p-2">MyRatings</h1>
      <div className="alerts">
        <MenuBtn />
      </div>
    </header>
  );
}

const NoAuthHeader = () => {
  return (
    <header className="header d-flex justify-content-between">
      <div className="noauth"> </div>
      <h1 className="p-2">MyRatings</h1>
      <div className="alerts"> </div>
    </header>
  );
}

const MenuBtn = () => {
  return(
    <div className="menu" onClick={openNav}>
      <div className="menubar"></div>
      <div className="menubar"></div>
      <div className="menubar"></div>
    </div>
  );
}

export default Header;